import { useEffect, useState } from 'react';

const MIN_INTERVAL_MS = 5000;
const MAX_INTERVAL_MS = 15000;

export const useCyclingMessage = (messages: Array<string>): string => {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * messages.length));

  useEffect(() => {
    if (messages.length <= 1) {
      return;
    }

    const timeoutId = setTimeout(() => {
      setIndex((prev) => getRandomIndex(prev, messages.length));
    }, getRandomInterval());

    return () => clearTimeout(timeoutId);
  }, [index, messages.length]);

  return messages[index] ?? messages[0];
};

const getRandomInterval = () => Math.floor(Math.random() * (MAX_INTERVAL_MS - MIN_INTERVAL_MS + 1)) + MIN_INTERVAL_MS;

const getRandomIndex = (currentIndex: number, length: number): number => {
  if (length <= 1) {
    return 0;
  }
  let nextIndex: number;
  do {
    nextIndex = Math.floor(Math.random() * length);
  } while (nextIndex === currentIndex);
  return nextIndex;
};
